export default function stringFormat() {
    const args = [].slice.call(arguments);
    return args[0].replace(/(\{\d+\})/g, function (arg) {
        return args[+(arg.substr(1, arg.length - 2)) || 1];
    });
}